(() => {
  /*
    REMPLACEZ LES VALEURS null PAR LES ENTRAXES MAXIMAUX
    EXACTS DE VOS FICHES TECHNIQUES FABRICANT.
    Le calcul est volontairement bloqué lorsque la valeur est null.
  */

  const DATA = {
    alveolaire: {
  products: [{
    id: 'alveolaire-standard',
    label: 'Plaque alvéolaire standard',
    supports: ['chevrons'],
    thicknesses: [
      {
        value: '4',
        label: '4 mm',
        maxSpan: 400
      },
      {
        value: '6',
        label: '6 mm',
        maxSpan: 500
      },
      {
        value: '8',
        label: '8 mm',
        maxSpan: 600
      },
      {
        value: '10',
        label: '10 mm',
        maxSpan: 800
      },
      {
        value: '16',
        label: '16 mm',
        maxSpan: 1000
      },
      {
        value: '32',
        label: '32 mm',
        maxSpan: 1200
      },
      {
        value: '35',
        label: '35 mm — étude technique nécessaire',
        maxSpan: null
      },
      {
        value: '55',
        label: '55 mm — étude technique nécessaire',
        maxSpan: null
      }
    ]
  }]
},

    compact: {
  products: [{
    id: 'compact-standard',
    label: 'Polycarbonate compact',
    supports: ['chevrons'],
    thicknesses: [
      {
        value: '2',
        label: '2 mm — non recommandé pour une toiture',
        maxSpan: null
      },
      {
        value: '3',
        label: '3 mm — non recommandé pour une toiture',
        maxSpan: null
      },
      {
        value: '4',
        label: '4 mm',
        maxSpan: 785
      },
      {
        value: '5',
        label: '5 mm',
        maxSpan: 980
      },
      {
        value: '6',
        label: '6 mm',
        maxSpan: 1175
      },
      {
        value: '8',
        label: '8 mm',
        maxSpan: 1575
      },
      {
        value: '10',
        label: '10 mm',
        maxSpan: 1960
      },
      {
        value: '12',
        label: '12 mm',
        maxSpan: 2050
      },
      {
        value: '15',
        label: '15 mm',
        maxSpan: 2050
      }
    ]
  }]
},

    ondule: {
      products: [
        {id:'78-16',label:'Ondulé transparent 0,8 mm – 78/16',supports:['pannes'],thicknesses:[{value:'0.8',label:'0,8 mm',maxSpan:600}]},
        {id:'diamante',label:'Ondulé diamanté transparent / bronze',supports:['pannes'],thicknesses:[{value:'2.8',label:'2,8 mm',maxSpan:1500}]},
        {
  id: 'greca',
  label: 'Ondulé Greca 76/16 – 0,8 mm',
  supports: ['pannes'],
  thicknesses: [
    {
      value: '0.8',
      label: '0,8 mm',
      maxSpan: 900
    }
  ]
},
        {id:'grande-onde',label:'Ondulé grande onde',supports:['pannes'],thicknesses:[{value:'1',label:'1 mm',maxSpan: 1200}]},
        {id:'omega',label:'Ondulé Omega',supports:['pannes'],thicknesses:[{value:'1',label:'1 mm',maxSpan: 700}]},
        {id:'nervure',label:'Ondulé nervuré',supports:['pannes'],thicknesses:[{value:'modele',label:'Selon modèle',maxSpan: 1000}]},
        {id:'ondule-alveolaire',label:'Ondulé alvéolaire transparent',supports:['pannes'],thicknesses:[{value:'6',label:'6 mm',maxSpan:885}]}
      ]
    },

    rglaze: {
      products: [{
        id:'r-glaze',
        label:'R-Glaze 3 mm',
        supports:['chevrons','pannes'],
        thicknesses:[{
          value:'3',
          label:'3 mm',
          maxSpanBySupport:{chevrons:600,pannes: 900}
        }]
      }]
    }
  };

  const LABELS = {
    chevrons:{
      dimension:'Largeur totale de la toiture',
      info:'Les chevrons sont disposés dans le sens de la pente. Le calcul porte sur la distance entre deux chevrons.',
      title:'Entraxe recommandé entre les chevrons',
      supports:'Nombre de chevrons',
      singular:'chevron',
      plural:'chevrons',
      diagram:'Répartition des chevrons'
    },
    pannes:{
      dimension:'Longueur de toiture dans le sens de la pente',
      info:'Les plaques reposent transversalement sur les pannes. Le calcul porte sur la distance entre deux lignes de pannes.',
      title:'Entraxe recommandé entre les pannes',
      supports:'Nombre de lignes de pannes',
      singular:'ligne de panne',
      plural:'lignes de pannes',
      diagram:'Répartition des lignes de pannes'
    }
  };

  class EntraxeCalculator {
    constructor(root){
      this.root=root;
      this.family=root.querySelector('[data-field="family"]');
      this.product=root.querySelector('[data-field="product"]');
      this.thickness=root.querySelector('[data-field="thickness"]');
      this.support=root.querySelector('[data-field="support"]');
      this.dimension=root.querySelector('[data-field="dimension"]');
      this.maxSpan=root.querySelector('[data-field="max-span"]');
      this.results=root.querySelector('[data-role="results"]');

      this.family.addEventListener('change',()=>this.updateProducts());
      this.product.addEventListener('change',()=>this.updateOptions());
      this.thickness.addEventListener('change',()=>this.updateSpan());
      this.support.addEventListener('change',()=>{this.updateLabels();this.updateSpan();});
      root.querySelector('[data-action="calculate"]').addEventListener('click',()=>this.calculate());

      this.updateProducts();
    }

    currentFamily(){return DATA[this.family.value]}
    currentProduct(){return this.currentFamily().products.find(x=>x.id===this.product.value)}
    currentThickness(){return this.currentProduct().thicknesses.find(x=>x.value===this.thickness.value)}

    updateProducts(){
      this.product.innerHTML=this.currentFamily().products.map(x=>`<option value="${x.id}">${x.label}</option>`).join('');
      this.updateOptions();
      this.results.hidden=true;
    }

    updateOptions(){
      const product=this.currentProduct();
      this.thickness.innerHTML=product.thicknesses.map(x=>`<option value="${x.value}">${x.label}</option>`).join('');
      this.support.innerHTML=product.supports.map(x=>`<option value="${x}">${x==='chevrons'?'Pose sur chevrons':'Pose sur pannes'}</option>`).join('');
      this.root.querySelector('[data-wrap="support"]').hidden=product.supports.length===1;
      this.updateLabels();
      this.updateSpan();
      this.results.hidden=true;
    }

    updateLabels(){
      const l=LABELS[this.support.value];
      this.root.querySelector('[data-role="dimension-label"]').textContent=l.dimension;
      this.root.querySelector('[data-role="support-info"]').innerHTML=`<strong>${l.dimension} :</strong> ${l.info}`;
    }

    updateSpan(){
      const t=this.currentThickness();
      const value=t.maxSpanBySupport?t.maxSpanBySupport[this.support.value]:t.maxSpan;
      this.maxSpan.value=value||'';
      this.root.querySelector('[data-role="span-source"]').innerHTML=value
        ?'Valeur technique configurée dans <strong>assets/entraxe.js</strong>.'
        :'Valeur à renseigner dans <strong>assets/entraxe.js</strong> selon la fiche technique fabricant.';
    }

    calculate(){
      const total=Number(this.dimension.value);
      const max=Number(this.maxSpan.value);

      if(!total||total<=0){this.error('Indiquez une dimension totale valide.');return}
      if(!max||max<=0){this.error('L’entraxe maximal de ce produit n’est pas encore configuré dans assets/entraxe.js.');return}

      const spaces=Math.max(1,Math.ceil(total/max));
      const supports=spaces+1;
      const real=total/spaces;
      const type=this.support.value;
      const l=LABELS[type];

      this.results.hidden=false;
      this.root.querySelector('[data-role="alert"]').innerHTML='';
      this.root.querySelector('[data-role="result-title"]').textContent=l.title;
      this.root.querySelector('[data-role="highlight-label"]').textContent=`Entraxe réel entre ${l.plural}`;
      this.root.querySelector('[data-result="real-span"]').textContent=`${Math.round(real)} mm`;
      this.root.querySelector('[data-result="dimension"]').textContent=`${Math.round(total)} mm`;
      this.root.querySelector('[data-result="max-span"]').textContent=`${Math.round(max)} mm`;
      this.root.querySelector('[data-result="spaces"]').textContent=spaces;
      this.root.querySelector('[data-result="supports"]').textContent=supports;
      this.root.querySelector('[data-role="supports-label"]').textContent=l.supports;
      this.root.querySelector('[data-role="diagram-title"]').textContent=l.diagram;

      const visible=Math.min(supports,18);
      this.root.querySelector('[data-role="diagram"]').innerHTML=
        `<div class="${type==='pannes'?'entraxe-pannes':'entraxe-chevrons'}">${Array.from({length:visible},()=>'<i></i>').join('')}</div>`;

      this.root.querySelector('[data-role="diagram-caption"]').textContent=
        supports>18?`Schéma simplifié : ${supports} supports au total — entraxe ${Math.round(real)} mm.`:
        `${supports} supports — entraxe réel ${Math.round(real)} mm.`;

      this.root.querySelector('[data-role="summary"]').innerHTML=
        `Pour une dimension totale de <strong>${Math.round(total)} mm</strong>, prévoyez <strong>${supports} ${supports>1?l.plural:l.singular}</strong>, soit <strong>${spaces} espace${spaces>1?'s':''}</strong> d’environ <strong>${Math.round(real)} mm</strong>.`;

      this.results.scrollIntoView({behavior:'smooth',block:'start'});
    }

    error(message){
      this.results.hidden=false;
      this.root.querySelector('[data-role="alert"]').innerHTML=`<div class="entraxe-alert-error">${message}</div>`;
      this.results.scrollIntoView({behavior:'smooth',block:'start'});
    }
  }

  const init=()=>{
    document.querySelectorAll('[data-entraxe-app]').forEach(root=>{
      if(root.dataset.entraxeInitialized==='true')return;
      root.dataset.entraxeInitialized='true';
      new EntraxeCalculator(root);
    });
  };

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  }else{
    init();
  }

  document.addEventListener('shopify:section:load',init);
})();